import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common/services/common.service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'iposcen-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit {
  tabIndex: number;
  currentdetailPage: string;
  showHideNavBar: boolean;
  loginUserRole = sessionStorage.getItem('userRole');
  showRetailGif = false;
  private ngUnsubscribe = new Subject<boolean>();
  deviceExecutiveRole: boolean = false;
  constructor(private router: Router, private cmnService: CommonService) { }

  ngOnInit(): void {
    if (this.loginUserRole === GlobalConstants.INTEL_ADMIN) {
      this.showHideNavBar = false;
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.DEVICES + GlobalConstants.SLASH + GlobalConstants.ACTIVE_DEVICE_REPORT);
    } else {
      this.showHideNavBar = true;
    }
    this.deviceExecutiveRole = this.loginUserRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE;
    this.cmnService.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if(data) {
        this.showRetailGif = true;
      }
    });
    this.tabIndex = 0;
    this.currentdetailPage = this.router.url;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.DEVICE_DASHBOARD) {
      this.tabIndex = 0;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ACTIVE_DEVICE_REPORT) {
      this.tabIndex = 1;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.DEVICE_STORE_LOGO) {
      this.tabIndex = 2;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.DEVICE_SETTINGS) {
      this.tabIndex = 3;
    }
  }

  setIndex(index: number) {
    if (index === 0) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.DEVICES + GlobalConstants.SLASH + GlobalConstants.DEVICE_DASHBOARD);
    } else if (index === 1) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.DEVICES + GlobalConstants.SLASH + GlobalConstants.ACTIVE_DEVICE_REPORT);
    } else if (index === 2) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.DEVICES + GlobalConstants.SLASH + GlobalConstants.DEVICE_STORE_LOGO);
    } else if (index === 3) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.DEVICES + GlobalConstants.SLASH + GlobalConstants.DEVICE_SETTINGS);
    }
  }

}
